import Accountancy from '../pages/departments/Accountancy';
import AgricTech from '../pages/departments/AgricTech';
import AgriculturalEngineering from '../pages/departments/AgriculturalEngineering';
import ArchiTech from '../pages/departments/ArchiTech';
import ArtificialIntelligent from '../pages/departments/ArtificialIntelligent';
import BankingFinance from '../pages/departments/BankingFinance';
import BuildingTech from '../pages/departments/BuildingTech';
import BusinessAdmin from '../pages/departments/BusinessAdmin';
import ChemicalEngineering from '../pages/departments/ChemicalEngineering';
import CivilEngineering from '../pages/departments/CivilEngineering';
import ComputerEngineering from '../pages/departments/ComputerEngineering';
import ComputerScience from '../pages/departments/ComputerScience';
import CropProduction from '../pages/departments/CropProduction';
import CyberSecurity from '../pages/departments/CyberSecurity';
import ElectricalEngineering from '../pages/departments/ElectricalEngineering';
import Environmental from '../pages/departments/Environmental';
import Estate from '../pages/departments/Estate';
import FilmMedia from '../pages/departments/FilmMedia';
import FoodScience from '../pages/departments/FoodScience';
import HealthInfo from '../pages/departments/HealthInfo';
import Horticultural from '../pages/departments/Horticultural';
import LivestockAnimalProduction from '../pages/departments/LivestockAnimalProduction';
import HospitalityManagement from '../pages/departments/HospitalityManagement';
import JournalStudies from '../pages/departments/JournalStudies';
import Languages from '../pages/departments/Languages';
import LegalStudies from '../pages/departments/LegalStudies';
import LibraryScience from '../pages/departments/LibraryScience';
import Marketing from '../pages/departments/Marketing';
import MassCommunication from '../pages/departments/MassCommunication';
import Mathematics from '../pages/departments/Mathematics';
import MechanicalEngineering from '../pages/departments/MechanicalEngineering';
import NetworkingCloud from '../pages/departments/NetworkingCloud';
import NutritionDietetics from '../pages/departments/NutritionDietetics';
import OfficeTech from '../pages/departments/OfficeTech';
import Procurement from '../pages/departments/Procurement';
import PublicAdministration from '../pages/departments/PublicAdministration';
import Quantity from '../pages/departments/Quantity';
import RenewableEnergyEngineering from '../pages/departments/RenewableEnergyEngineering';
import ScienceLab from '../pages/departments/ScienceLab';
import ScienceLabBio from '../pages/departments/ScienceLabBio';
import ScienceLabChem from '../pages/departments/ScienceLabChem';
import ScienceLabPhy from '../pages/departments/ScienceLabPhy';
import SocialS from '../pages/departments/SocialS';
import SoftwareWeb from '../pages/departments/SoftwareWeb';
import Statistics from '../pages/departments/Statistics';
import Strategic from '../pages/departments/Strategic';
import Surveying from '../pages/departments/Surveying';
import Taxation from '../pages/departments/Taxation';
import TourismManagement from '../pages/departments/TourismManagement';
import Urban from '../pages/departments/Urban';

const slugify = (value) => String(value || '')
  .toLowerCase()
  .trim()
  .replace(/&/g, 'and')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/(^-|-$)/g, '');

const registryEntries = [
  ['accountancy', Accountancy],
  ['agricultural-technology', AgricTech],
  ['agricultural-and-bio-environmental-engineering', AgriculturalEngineering],
  ['agricultural-and-bioenvironmental-engineering', AgriculturalEngineering],
  ['architectural-technology', ArchiTech],
  ['artificial-intelligence-technology', ArtificialIntelligent],
  ['banking-and-finance', BankingFinance],
  ['building-technology', BuildingTech],
  ['business-administration-and-management', BusinessAdmin],
  ['chemical-engineering', ChemicalEngineering],
  ['civil-engineering', CivilEngineering],
  ['computer-engineering', ComputerEngineering],
  ['computer-science', ComputerScience],
  ['crop-production-technology', CropProduction],
  ['cyber-security-and-data-protection', CyberSecurity],
  ['electrical-engineering', ElectricalEngineering],
  ['environmental-science-and-management', Environmental],
  ['estate-management-and-valuation', Estate],
  ['film-and-media-studies', FilmMedia],
  ['food-science-and-technology', FoodScience],
  ['health-information-management-technology', HealthInfo],
  ['horticulture-and-landscape-technology', Horticultural],
  ['horticultural-technology', Horticultural],
  ['hospitality-management', HospitalityManagement],
  ['journalism-and-media-studies', JournalStudies],
  ['journal-studies', JournalStudies],
  ['languages', Languages],
  ['legal-studies', LegalStudies],
  ['livestock-and-animal-production-technology', LivestockAnimalProduction],
  ['library-and-information-science', LibraryScience],
  ['marketing', Marketing],
  ['mass-communication', MassCommunication],
  ['mathematics', Mathematics],
  ['mechanical-engineering', MechanicalEngineering],
  ['networking-and-cloud-computing', NetworkingCloud],
  ['office-of-technology-management', OfficeTech],
  ['office-technology-management', OfficeTech],
  ['procurement-and-supply-chain-management', Procurement],
  ['public-administration', PublicAdministration],
  ['quantity-surveying', Quantity],
  ['renewable-energy-engineering', RenewableEnergyEngineering],
  ['science-laboratory-technology', ScienceLab],
  ['science-laboratory-technology-biological-sciences', ScienceLabBio],
  ['science-laboratory-technology-biological-sciences-', ScienceLabBio],
  ['science-laboratory-technology-chemical-sciences', ScienceLabChem],
  ['science-laboratory-technology-chemical-sciences-', ScienceLabChem],
  ['science-laboratory-technology-physics', ScienceLabPhy],
  ['science-laboratory-technology-physics-', ScienceLabPhy],
  ['social-sciences', SocialS],
  ['software-and-web-development', SoftwareWeb],
  ['statistics', Statistics],
  ['strategic-communication-and-media-studies', Strategic],
  ['surveying-and-geoinformatics', Surveying],
  ['taxation', Taxation],
  ['tourism-management-technology', TourismManagement],
  ['urban-and-regional-planning', Urban],
];

const registry = new Map(registryEntries.map(([slug, Component]) => [slugify(slug), Component]));

export function getLegacyDepartmentComponent(slugOrName) {
  return registry.get(slugify(slugOrName));
}

export function hasLegacyDepartmentContent(slugOrName) {
  return registry.has(slugify(slugOrName));
}
